import { GetUserUserIdAppealResponse } from "../../api/v1/user/[user_id]/appeal/getResponse"
import { UserAppeal } from "./UserAppeal"

export const adaptUserAppeal = (
  res: GetUserUserIdAppealResponse | null,
): UserAppeal => {
  return {
    appealComment: res ? res.appeal_comment : null,
  }
}
